const label = (field) => {
    if (field === "telgebied") {
        switch (parseInt(process.env.REACT_APP_PROJECTID)) {
            case 57:
                return "Cluster"
            default:
                return "Telgebied"
        }
    }
    return field
}
export default label